import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { admin } from '../../utils/api';

const PageTitle = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const [siteSettings, setSiteSettings] = useState(null);

  useEffect(() => {
    // Set page title based on the current location and site settings
    const fetchSiteSettings = async () => {
      try {
        const settings = await admin.getPublicSiteSettings();
        setSiteSettings(settings);
      } catch (error) {
        console.error('Error fetching site settings:', error);
      }
    };

    fetchSiteSettings();
  }, []);

  useEffect(() => {
    const updateTitle = async () => {
      try {
        // Get site settings
        const settings = siteSettings || await admin.getPublicSiteSettings();
        const siteName = settings?.siteName || 'CAMATS TEAM RACING';

        // Get section name from path
        const path = location.pathname;
        const segments = path.split('/').filter(segment => segment);
        let sectionName = 'Home';
        
        if (segments.length > 0) {
          // Map URL segments to section names
          const sectionMap = {
            'admin': 'Admin',
            'workshop': 'Workshop',
            'cars': 'Cars',
            'events': 'Events',
            'gallery': 'Gallery',
            'payments': 'Payments',
            'racetracks': 'Racetracks',
            'sponsors': 'Sponsors',
            'team': 'Team',
            'calendar': 'Calendar'
          };
          
          sectionName = sectionMap[segments[0]] || segments[0].charAt(0).toUpperCase() + segments[0].slice(1).replace(/-/g, ' ');
        }

        // Update document title
        document.title = `${siteName} - ${sectionName}`;
      } catch (error) {
        // Fallback to default title if fetch fails
        const sectionName = location.pathname.split('/')[1]?.charAt(0).toUpperCase() + 
                           location.pathname.split('/')[1]?.slice(1).replace(/-/g, ' ') || 'Home';
        document.title = `CAMATS TEAM RACING - ${sectionName}`;
      }
    };

    updateTitle();
  }, [location.pathname, siteSettings]);

  return null;
};

export default PageTitle; 